import { useCallback, useReducer, useState } from 'react';
import { useTableState } from '../../Table/useTableState';
import { TreeTableState } from '../TreeTableState';
export const useTreeTableState = (initialExpandedNodes, initialPreference) => {
  const [expandedNodes, setExpandedNodes] = useState(initialExpandedNodes);
  const [treeTableState, treeDispatch] = useReducer(TreeTableState.reducer, TreeTableState.init(initialPreference?.selectedRows, initialPreference?.partiallySelectedRows));
  const partiallySelectedRows = treeTableState.partiallySelectedRows;
  const {
    dispatch,
    ...tableState
  } = useTableState(initialPreference);
  const onExpand = (node, expanded) => {
    const nodes = new Set(expandedNodes);
    if (nodes.has(node.id) && !expanded) nodes.delete(node.id);else if (!nodes.has(node.id) && expanded) nodes.add(node.id);
    setExpandedNodes(nodes);
  };
  const setSelectAllRows = useCallback(props => {
    treeDispatch({
      type: 'clearPartiallySelectedRows'
    });
    const setSelectAllRows = tableState.setSelectAllRows;
    setSelectAllRows(props);
  }, [tableState.setSelectAllRows]);
  const setTreeSelection = useCallback(props => {
    treeDispatch({
      type: 'selectRow',
      ...props
    });
  }, []);
  const setParentChildSelection = useCallback(props => {
    treeDispatch({
      type: 'parentChildSelection',
      ...props
    });
  }, []);
  return {
    expandedNodes,
    setExpandedNodes,
    onExpand,
    ...tableState,
    treeDispatch,
    setSelectAllRows,
    setTreeSelection,
    setParentChildSelection,
    partiallySelectedRows
  };
};
//# sourceMappingURL=useTreeTableState.js.map